import type { GetServerSidePropsContext } from 'next';
import { EcoProvider } from 'lowcode/utils/context/ecocredits';
import Product from 'lowcode/pages/product';
import MemberGloData from 'lowcode/utils/MemberGloData';
import { MemberTimeProvider } from 'lowcode/utils/context/memberTimeZone';
import { queryEditorDetailOnline } from 'lowcode/utils/service';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import { useLang } from '@/i18n';
import SEOlinksA from '@/components/SEOlinksA';
import getLocal from '@/app/utils/getLocal';
import seoconfig from '@/seoconfig/members-store';
import SEO from '@/components/utils/SEO';
import { redirectTo404 } from '@/utils';
import MembersStoreCompoment from '@/components/MembersStore';
import StoreContext from '@/components/MembersStore/StoreProvider';

export default function MembersStore({ isLogin, membersDayData, id, data }: any) {
    const { isApp } = useGlobal();
    const { locale } = getLocal();
    const { t } = useLang('membersstore');

    return (
        <>
            <style jsx global>
                {`
                    .ant-modal-root {
                        z-index: 2113;
                    }
                `}
            </style>
            <SEO title={t('seo.title')} description={t('seo.desc')} />
            <SEOlinksA locale={String(locale)} list={['us', 'ca']} pathname={seoconfig.url} />
            <PageLayout isNoFixed hideFooter={isApp} hideHeader={isApp} theme="black">
                <StoreContext value={{ isLogin, protocol: membersDayData.protocol }}>
                    <MembersStoreCompoment id={id} data={data} />
                </StoreContext>
            </PageLayout>
        </>
    );
}

export async function getServerSideProps({ locale, req }: GetServerSidePropsContext) {
    const whiteLocaleList = ['us', 'ca'];

    let membersDayData = null;

    try {
        membersDayData = require(`@/data/membersstore/${locale}.js`);
    } catch (err) {
        membersDayData = require(`@/data/membersstore/us.js`);
    }

    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }

    const userInfoJson = req.cookies?.userInfo || '';
    let isLogin = false;
    try {
        const userInfo = JSON.parse(userInfoJson);
        isLogin = !!userInfo.token;
    } catch {}

    // 配置化
    let data = {
        thePage: {},
        theTemp: [],
        theData: {},
        theAttr: {},
        sqlData: {},
    };
    const id = 'members-store';
    try {
        data = await queryEditorDetailOnline(id, locale as string);
    } catch (e: any) {}

    return {
        props: {
            isLogin,
            membersDayData,
            id,
            data,
        },
    };
}
